export interface SignOffPerson {
  personDisplayName: string;
  signOffDate: string | null;
}

export enum SignOffState {
  NOT_SIGNED_OFF = 'not_signed_off',
  SIGNED_OFF = 'signed_off',
  CONFIGURATION_ISSUE = 'configuration_issue',
}
